import Header from '../../components/HomeHeader';
import Footer from '../../components/Footer';
import './styles.css';

function Home() {
  return (
    <div className="main">
      <Header/>
      
        {/* Course */}
        <section class="course">
            <h1>Courses We Offer</h1>
            <p>we offer a diverse range of courses designed to meet the evolving needs of today's dynamic world. Our comprehensive curriculum is carefully crafted to equip students with the knowledge, skills, and practical experience necessary to excel in their chosen fields.</p>

            <div class="row">
                <div class="course-col">
                    <h3>Intermediate</h3>
                    <p>we understand the importance of providing a diverse range of educational opportunities to meet the unique needs and aspirations of our students. Our intermediate programs are designed to bridge the gap between foundational knowledge and specialized fields, equipping students with the skills and knowledge necessary for success in their chosen career paths or further academic pursuits.</p>
                </div>
                <div class="course-col">
                    <h3>Degree</h3>
                    <p>we offer a diverse range of degree programs designed to equip students with the knowledge, skills, and experience necessary to thrive in their chosen fields. Our degrees are thoughtfully crafted to provide a comprehensive and well-rounded education that prepares students for the challenges and opportunities of the modern world.</p>
                </div>
                <div class="course-col">
                    <h3>Post Graduation</h3>
                    <p>Our post-graduation programs offer a diverse range of disciplines, allowing students to specialize in areas that align with their passions and career goals. Whether you aspire to become a leader in business, a trailblazer in scientific research, an expert in technology, or a visionary in the arts, we have a program tailored to meet your unique aspirations. Join us and unlock your potential for a successful and fulfilling career.</p>
                </div>
            </div>
        </section>
  
        {/* Campus */}
        <section class="campus">
            <h1>Our Global Campus</h1>
            <p>Bright Eyes University offers an extraordinary opportunity for students to embark on a transformative educational journey that transcends borders and expands horizons. As a university committed to fostering global citizenship and embracing cultural diversity, we understand the immense value of providing our students with a truly international learning experience.</p>
            <div class="row">
                <div class="campus-col">
                    <img src={'https://images.unsplash.com/photo-1518972899944-21fd2f2be2d5?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1yZWxhdGVkfDE4fHx8ZW58MHx8fHx8&auto=format&fit=crop&w=500&q=60'} alt=''/>
                    <div class="layer">
                        <h3>LONDON</h3>
                    </div>
                </div>
                <div class="campus-col">
                    <img src={'https://images.unsplash.com/photo-1554127391-42d8bfe379d9?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1yZWxhdGVkfDEyfHx8ZW58MHx8fHx8&auto=format&fit=crop&w=500&q=60'} alt=''/>
                    <div class="layer">
                        <h3>NEW YORK</h3>
                    </div>
                </div>
                <div class="campus-col">
                    <img src={'https://images.unsplash.com/photo-1579693858422-872c45641e43?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1yZWxhdGVkfDE5fHx8ZW58MHx8fHx8&auto=format&fit=crop&w=500&q=60'} alt=''/>
                    <div class="layer">
                        <h3>WASHINGTON</h3>
                    </div>
                </div>
            </div>
        </section>

        {/* Facilities */}
        <section class="facilities">
            <h1>Our Facilities</h1>
            <p>Our university boasts a wide range of facilities designed to enhance the learning, and experience of our students and faculty members.</p>

            <div class="row">
                <div class="facilities-col">
                    <img src={'https://media.istockphoto.com/id/1449285433/photo/school-library.webp?s=170667a&w=0&k=20&c=NNZn7e29MxBOsJZOdRrVGh27rZCHIJsAvBLKE7KeLuI='} alt='' />
                    <h3>World Class Library</h3>
                    <p>library of our university, where knowledge knows no bounds and information is at your fingertips. Our library stands as a beacon of academic excellence, offering a rich collection of resources and a serene environment for intellectual exploration.</p>
                </div>
                <div class="facilities-col">
                    <img src={'https://images.unsplash.com/photo-1547347298-4074fc3086f0?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1yZWxhdGVkfDJ8fHxlbnwwfHx8fHw%3D&auto=format&fit=crop&w=500&q=60'} alt='' />
                    <h3>Largest Play Ground</h3>
                    <p>The university play grounds are sprawling outdoor spaces designed to promote physical activity, sportsmanship, and recreational opportunities for students, faculty, and staff. These play grounds are meticulously maintained and offer a range of facilities and amenities.</p>
                </div>
                <div class="facilities-col">
                    <img src={'https://media.istockphoto.com/id/682880248/photo/a-nice-time-to-enjoy-coffee-and-cake.webp?s=170667a&w=0&k=20&c=Px3rRo6au2NjG5ohBLBu_K7mzcjkm6HscUH8BqOr4gQ='} alt='' />
                    <h3>Tasty and Healthy Food</h3>
                    <p>At our university, we understand the importance of providing tasty and healthy food options to support the overall well-being of our students and faculty members.</p>
                </div>
            </div>
        </section>
      <Footer/>
    </div>
  );
}

export default Home;
